import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum TradingGroupsFormErrorStatesEnum {
    RegisterGroupFailed = ErrorStateScheduleEnum.TradingGroupsFormStatesStartIndex,
    UpdateTradingGroupStatusFailed,
    GetTradingGroupStatusTriggersFailed
}
